<template>
    <v-tooltip bottom :disabled="!obj.schema.disabled" open-on-hover content-class="myprovet-tooltip">
        <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
                <v-text-field v-bind="{ ...obj.schema }" clearable  v-on:input="handleInput($event)" :value="value"> </v-text-field>
            </div>
        </template>
        <span class="font-size-md"> {{ textToDisplay }}</span>
    </v-tooltip>
</template>

<script>
export default {
    props: ['type', 'value', 'obj'],

    data() {
        return {
            _timer: null,
        };
    },

    computed: {
        textToDisplay() {
            return this.$t('clientMenu.notWithAdvanced');
        },
    },

    methods: {
        /*handleInput(event) {
            // Debounce the search
            clearTimeout(this._timer);

            this._timer = setTimeout(() => {
                this.$emit('input', event ?? '');
            }, 1000);
        },*/
        handleInput: _.debounce(function(event){
            // Debounce the search
            this.$emit('input', event ?? '');
        }, 500),
    },
};
</script>

<style></style>
